<div class="main-header main-header-fullwidth main-header-has-header-standard">
  <!-- Header Standard Landing  -->

  <div
    class="header--standard header--standard-landing"
    [ngClass]="{
      'animated headroom--not-bottom headroom--not-top headroom--unpinned':
        bgHeader
    }"
  >
    <div class="container">
      <div class="header--standard-wrap">
        <a [routerLink]="'/home'" class="logo">
          <div class="img-wrap">
            <img src="/assets/svg-icons/Logo ACP.svg" alt="Olympus" />
          </div>
        </a>

        <app-header-language class="for-mobile"></app-header-language>
        <a class="open-responsive-menu js-open-responsive-menu">
          <svg class="olymp-menu-icon">
            <use
              xlink:href="assets/svg-icons/sprites/icons.svg#olymp-menu-icon"
            ></use>
          </svg>
        </a>

        <div class="nav nav-pills nav1 header-menu expanded-menu">
          <div class="mCustomScrollbar pimary-menu">
            <ul class="pages-menu">
              <li class="nav-item">
                <a
                  [routerLink]="'/home'"
                  [routerLinkActive]="'active'"
                  class="nav-link"
                  >{{ "HOME" | translate }}</a
                >
              </li>
              <li class="nav-item">
                <a
                  [routerLink]="'/events'"
                  [routerLinkActive]="'active'"
                  class="nav-link"
                  >{{ "EVENTS" | translate }}</a
                >
              </li>
            </ul>
            <app-header-language class="for-desktop"></app-header-language>
            <ul class="connexion" *ngIf="module != 'auth' && !connectedUser">
              <li class="sign-up">
                <!-- /events/FITA2025 -->

                <a class="nav-link" [routerLink]="'/authentication/sign-up'">
                  {{ "SIGNUP" | translate }}
                </a>
              </li>

              <li class="sign-in">
                <a class="nav-link" [routerLink]="'/authentication'">
                  {{ "LOGIN" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="control-block ml-50 mr-0 connected-user"
          *ngIf="connectedUser && module != 'auth'"
        >
          <div class="author-page author vcard inline-items more">
            <div class="author-thumb">
              <img
                alt="author"
                [src]="connectedUser.profilePicture"
                class="avatar"
              />
              <span class="icon-status online"></span>
              <div class="more-dropdown more-with-triangle">
                <div class="mCustomScrollbar" data-mcs-theme="dark">
                  <div class="ui-block-title ui-block-title-small">
                    <h6 class="title">{{ "YOUR_ACCOUNT" | translate }}</h6>
                  </div>

                  <ul class="account-settings">
                    <!-- <li>
											<a [routerLink]="'/portal/'" *ngIf="connectedUser.role == 'ADMIN'">
												<svg class="olymp-menu-icon"><use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-menu-icon"></use></svg>
												<span>{{'PORTAL_LABEL' | translate}}</span>
											</a>
										</li> -->
                    <li>
                      <a [routerLink]="'/portal/settings'">
                        <i class="far fa-user"></i>
                        <span>{{ "PROFILE" | translate }}</span>
                      </a>
                    </li>
                    <li *ngIf="connectedUser?.role == 'ADMIN'">
                      <a [routerLink]="'/portal/configuration/custom-list'">
                        <svg class="olymp-settings-icon">
                          <use
                            xlink:href="assets/svg-icons/sprites/icons.svg#olymp-settings-icon"
                          ></use>
                        </svg>
                        <span>{{ "CONFIGURATION" | translate }}</span>
                      </a>
                    </li>
                    <li *ngIf="connectedUser?.role == 'ADMIN'">
                      <a [routerLink]="'/portal/events'">
                        <svg class="olymp-calendar-icon">
                          <use
                            xlink:href="assets/svg-icons/sprites/icons.svg#olymp-calendar-icon"
                          ></use>
                        </svg>
                        <span>{{ "EVENTS" | translate }}</span>
                      </a>
                    </li>
                    <li>
                      <a [routerLink]="" (click)="logout()">
                        <svg class="olymp-logout-icon">
                          <use
                            xlink:href="assets/svg-icons/sprites/icons.svg#olymp-logout-icon"
                          ></use>
                        </svg>
                        <span>{{ "LOGOUT" | translate }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <a class="author-name fn">
              <div class="author-title">
                {{ connectedUser.first_name }} {{ connectedUser.last_name }}
                <svg class="olymp-dropdown-arrow-icon">
                  <use
                    xlink:href="assets/svg-icons/sprites/icons.svg#olymp-dropdown-arrow-icon"
                  ></use>
                </svg>
              </div>
              <span class="author-subtitle">{{ connectedUser.role }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ... end Header Standard Landing  -->
</div>
